import { useState, useEffect } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsApp = () => {
    window.open('https://wa.me/56944540956', '_blank');
  };

  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">

      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/2ad3fb6c05d021c5287c0e38d7178004.jpg"
          alt="Consultoría de salud premium"
          className="w-full h-full object-cover object-center"
        />
        {/* Multi-layer overlay for depth and readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0F172A]/80 via-[#0F172A]/60 to-[#0F172A]/30"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/50 via-transparent to-transparent"></div>
      </div>

      {/* Navbar */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled
            ? 'bg-white/95 backdrop-blur-md border-b border-gray-100'
            : 'bg-white/10 backdrop-blur-sm'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex items-center justify-between h-20">

            {/* Brand */}
            <div className="flex items-center space-x-3">
              <div>
                <h1
                  className={`text-lg font-semibold tracking-tight transition-colors duration-500 ${
                    scrolled ? 'text-[#0F172A]' : 'text-white'
                  }`}
                >
                  Susana Asesora de Salud
                </h1>
                <p
                  className={`text-xs tracking-wide transition-colors duration-500 ${
                    scrolled ? 'text-slate-500' : 'text-white/70'
                  }`}
                >
                  Orientación personalizada
                </p>
              </div>
            </div>

            {/* CTA Button */}
            <button
              onClick={handleWhatsApp}
              className={`hidden md:flex items-center space-x-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap ${
                scrolled
                  ? 'bg-[#1D4ED8] text-white hover:bg-[#1e40af]'
                  : 'bg-white/15 backdrop-blur-sm text-white border border-white/30 hover:bg-white/25'
              }`}
            >
              <i className="ri-whatsapp-line text-base"></i>
              <span>Contactar</span>
            </button>

          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pt-32 pb-28 lg:pt-40 lg:pb-36">
        <div className="max-w-2xl space-y-8">

          {/* Heading */}
          <div className="space-y-5">
            <h2 className="text-5xl lg:text-6xl xl:text-[4rem] font-bold text-white leading-[1.1] tracking-tight">
              Te ayudo a entender y gestionar mejor tu plan de salud
            </h2>
            <p className="text-lg lg:text-xl text-white/75 leading-relaxed font-light max-w-xl">
              Asesoría personalizada, orientación comercial y acompañamiento cercano para resolver dudas sobre planes, beneficios y gestiones de salud previsional en todo Chile.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 pt-2">
            <button
              onClick={handleWhatsApp}
              className="flex items-center justify-center space-x-2.5 px-8 py-4 bg-[#1D4ED8] text-white rounded-full hover:bg-[#1e40af] transition-all duration-300 whitespace-nowrap font-medium text-[15px] group"
            >
              <i className="ri-whatsapp-line text-lg group-hover:scale-110 transition-transform"></i>
              <span>Hablar por WhatsApp</span>
            </button>
            <button
              onClick={scrollToContact}
              className="flex items-center justify-center space-x-2.5 px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-full border border-white/30 hover:bg-white/20 transition-all duration-300 whitespace-nowrap font-medium text-[15px]"
            >
              <i className="ri-mail-line text-lg"></i>
              <span>Solicitar orientación</span>
            </button>
          </div>

        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-xl text-white/40"></i>
      </div>

    </section>
  );
}
